// Auto-generated build info - DO NOT EDIT
export const BUILD_INFO = {
  timestamp: '2025-10-27T16:46:44.349Z',
  version: '1761583604350',
  commit: 'local',
  environment: import.meta.env.MODE
};

// Log build info on import
console.log('🏗️ [Build Info]', BUILD_INFO);
